import axios from "axios";
import { isNative, NATIVE_WEB_ORIGIN } from "@/lib/native";

// Web: env-provided backend. Native Capacitor shell (origin https://localhost): production domain.
const BACKEND_URL = isNative() ? NATIVE_WEB_ORIGIN : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Reject HTML responses (SPA fallback / misrouted API) so they are never mistaken for valid JSON data.
const rejectHtml = (response) => {
  const type = response.headers?.["content-type"] || "";
  if (typeof response.data === "string" && type.includes("text/html")) {
    return Promise.reject(new Error("API returned HTML instead of JSON"));
  }
  return response;
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
api.interceptors.response.use(rejectHtml);

// Attach admin token header automatically for admin-protected calls.
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});
adminApi.interceptors.response.use(rejectHtml);

export const setAdminToken = (token) => {
  if (token) {
    adminApi.defaults.headers.common["X-Admin-Token"] = token;
  } else {
    delete adminApi.defaults.headers.common["X-Admin-Token"];
  }
};

export const WHATSAPP_NUMBER = "918637522628";
let whatsappNumber = WHATSAPP_NUMBER;

export const setWhatsAppNumber = (n) => {
  if (n) whatsappNumber = String(n).replace(/\D/g, "");
};

export const getWhatsAppNumber = () => whatsappNumber;

export const openWhatsApp = (message, number) => {
  const url = `https://wa.me/${number || whatsappNumber}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};
